const authFlowRoutes = ['/auth/login', '/auth/silent-refresh', '/auth/logout'];

export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthNStore();
  const authClientStore = useAuthClientStore();
  const user = await authClientStore.zitadel.getUser();

  if (user && !authFlowRoutes.includes(to.path)) {
    authStore.setUser(user);
    // The stored user may have expired while the app was closed: refresh it (or drop it when the
    // session is gone) before page middleware starts sending requests with its token.
    await authClientStore.getValidAccessToken();
  }
});
